<template>
  <div class="scheduler" :class="{ 'later': selectedRow && selectedRow.key === 'later' }">
    <sb-async-dropdown
      :rows="rows"
      :options="options"
      :selected="selectedRow"
      :focused="dropdownFocused"
      @update:focused="shouldUpdateFocused"
      @update:selected="shouldUpdateSelected"
    />

    <section class='later-display all-can-error' v-if="selectedRow && selectedRow.key === 'later'">
      <span>select date</span>

      <sb-date
        class="sb-white-input"
        :class="{ errored }"
        data-cy="calendar-scheduler"
        :value="selectedTime"
        @update:value="$emit('update:selected-time', $event)"
        :include="['date', 'time']"
        :flatpickr="flatpickrConfig"
        format="EEE MMM d, Y hh:mm aa"
      />

      <section class='time-range-container' v-if='hasTimeRange'>
        <div>this sponsored ad must be sent in between</div>
        <div class='time-range' :class="{ errored }">{{ minStr }} - {{ maxStr }}</div>
      </section>
    </section>
  </div>
</template>

<script>
import Radios from '../shared/Radios'
import { format, isAfter, getHours, getMinutes } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { mapState } from 'vuex'

const sendNow = {
  slot: 'select-row',
  state: {
    key: 'now',
    label: 'send now'
  }
};

const sendLater = {
  slot: 'select-row',
  state: {
    key: 'later',
    label: 'send later'
  }
};

export default {
  props: {
    range: Object,
    selectedTime: Date,
    selectedMode: String
  },

  name: 'Scheduler',

  components: {
    Radios,
  },

  data() {
    return {
      laterTime: null,
      selectedRow: null,
      dropdownFocused: false,
      options: {
        label(selected) {
          return selected.label;
        }
      }
    }
  },

  created() {
    this.selectRowForMode(this.selectedMode);
  },

  methods: {
    shouldUpdateFocused(newFocused) {
      if(this.rows.length === 0) {
        this.dropdownFocused = false;
      } else {
        this.dropdownFocused = newFocused;
      }
    },
    shouldUpdateSelected(state) {
      this.$emit('update:selected-mode', state.key);
    },
    selectRowForMode(mode) {
      const row = this.rows.find((row) => row.state.key === mode);

      if(!row) {
        this.$emit('update:selected-mode', this.rows[0].state.key);
      } else {
        this.selectedRow = row.state;
      }
    },
  },

  computed: {
    hasTimeRange() {
      return this.range?.time.min && this.range?.time.max
    },

    min() {
      return this.range?.time.min
    },

    max() {
      return this.range?.time.max
    },

    minStr() {
      return format(this.min, 'ha')
    },

    maxStr() {
      return format(this.max, 'ha')
    },

    rows() {
      return [ sendNow, sendLater ].filter(element => this.selectedRow !== element.state);
    },

    flatpickrConfig() {
    let  merchantTime =  utcToZonedTime(new Date(), this.currentMerchant.merchant_time_zone)
      return {
        minDate: merchantTime,
        maxDate: this.range?.date.max,
        altInputClass: 'noCalendar hasTime',
        defaultHour: getHours(this.merchantTime),
        defaultMinute: getMinutes(this.merchantTime)
      }
    },

    minFlatpickrDate() {
      const now = new Date();
      return isAfter(this.min, now) ? this.min : now
    },

    merchantTime() {
      return utcToZonedTime(new Date(), this.currentMerchant.merchant_time_zone);
    },

    errored() {
      if(!this.hasTimeRange) {
        return false;
      }

      if(!this.selectedTime) {
        return true;
      }

      return this.range.time.min.getHours() > this.selectedTime.getHours() || this.range.time.max.getHours() <= this.selectedTime.getHours();
    },

    ...mapState([ 'currentMerchant' ]),
  },

  watch: {
    selectedMode(newMode) {
      this.selectRowForMode(newMode);
    }
  }
}
</script>

<style scoped>
.sb-base-dropdown {
  margin-bottom: 0px !important;
  white-space: nowrap;
  border-radius: 16px !important;
}

.sb-white-input >>> .label-container{
  font-size: 1rem;
  text-align: left !important;
  padding: 5px 15px !important;
}

.sb-base-dropdown .label-container {
  height: 100%;
  justify-content: center;
  border-radius: 16px;
}
.sb-base-dropdown.focused .label-container {
  border-radius: 16px 16px 0 0;
}

.sb-base-dropdown .sb-content {
  border-radius: 0 0 16px 16px;
}

.scheduler {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin-top: 40px;
}

.scheduler .later-display {
  border-width: 1px 1px 1px 0px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-style: solid;
  border-color: #128ff9;
  margin-left: -15px;
  padding-left: 30px;
}

.later-display {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: 15px;
}

.scheduler-section .sb-tabs .item .label {
  background: unset;
  line-height: 1em;
  padding: .5rem;
}

.scheduler-section .sb-tabs .items-container {
  overflow: hidden;
}

.scheduler-section .sb-tabs .items-container .item {
  overflow: hidden;
}

.time-range-container {
  position: absolute;
  bottom: -50px;
  text-align: center;
}

.time-range.errored {
  color: #f91253
}

.sb-date.errored .label-container {
  color: #f91253;
  border-color: #f91253;
}
.scheduler .sb-async-dropdown >>> .label-container {
  border-radius: 16px;
  font-family: AileronThin;
  width: 175px;
}

.scheduler .sb-async-dropdown >>> .label-container,
.scheduler .sb-async-dropdown >>> .sb-content {
  font-size: 18px;
}
.scheduler .sb-async-dropdown.focused >>> .label-container {
  border-radius: 16px 16px 0 0;
}
.scheduler .sb-async-dropdown.focused >>> .sb-content {
  border-radius: 0 0 16px 16px;
  text-align: center;
}

.scheduler .later-display {
  border-radius: 0 16px 16px 0;
}

@media only screen and (max-width: 1023px) {
  .later-display {
    padding: 0 15px 0 30px;
  }
}
</style>
